import { AxiosResponse } from "axios";
import { createLogger } from "logging";
const logger = createLogger("downloadHelper.ts");

export const triggerDownload = (content: BlobPart, fileName: string, contentType?: string) => {
  const blob = new Blob([content], contentType ? { type: contentType } : undefined);
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);

  a.click();
  a.remove();

  window.URL.revokeObjectURL(url);
};

export function getFileName(reponse: AxiosResponse, defaultValue = "Unknown.bin"): string {
  const header = reponse.headers["content-disposition"] || "";

  // Try to match filename* (RFC 5987) which contains UTF-8 encoded special characters
  const utf8Match = header.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match) {
    const decoded = decodeURIComponent(utf8Match[1]);
    logger.debug(`getFileName(): `, decoded);
    return decoded;
  }

  // Fallback to regular filename
  const match = header.match(/filename="?([^;]+)"?;?/);
  let value = match ? match[1] : defaultValue;
  value = value.replace(/^"+|"+$/g, "");
  logger.debug(`getFileName(): `, value);
  return value;
}

export function getContentType(reponse: AxiosResponse, defaultValue = "application/octet-stream"): string {
  let value = reponse.headers["content-type"]?.toString() || defaultValue;
  logger.debug(`getContentType(): `, value);
  return value;
}

export function getSbbIcon(fileName: string) {
  const extension = fileName.split(".").pop() || "";
  if (extension.startsWith("doc")) return "document-doc-small";
  if (extension.startsWith("ppt")) return "document-ppt-small";
  if (extension.startsWith("pdf")) return "document-pdf-small";
  if (extension.startsWith("txt")) return "document-text-small";
  if (extension.startsWith("zip")) return "document-zip-small";
  return "document-standard-small";
}
